// 価格とカートの有効/無効をまとめて切り替える
function setCheckoutUIEnabled(on) {
  const price = document.querySelector('.check_price');
  const cart  = document.querySelector('.cart--btn');

  if (price) {
    // クリア時：style=""、初期化/エラー時：visibility: hidden
    price.setAttribute('style', on ? '' : 'visibility: hidden');
  }
  if (cart) {
    // クリア時：disabled除去、初期化/エラー時：disabled付与
    if (on) cart.removeAttribute('disabled');
    else    cart.setAttribute('disabled', '');
  }
}

let kizonList = null;

// 一度だけCSVを読み込む
function loadKizonOnce() {
  if (Array.isArray(kizonList)) return Promise.resolve(kizonList);
  return $.ajax({
    url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer-bench_existing.csv?v=1762914041",
    dataType: "text"
  }).then(text => {
    kizonList = $.csv.toArrays(text);
    return kizonList;
  }).catch(() => {
    kizonList = []; // 読めなかったら空配列
    return kizonList;
  });
}

// DOMContentLoadedで先に読み込んでおく
document.addEventListener("DOMContentLoaded", () => {
  loadKizonOnce();
});

// 1) 初期化の単一窓口
function resetToDefaults({ skipWhenQuery = true } = {}) {
  setCheckoutUIEnabled(false);
  //removeOrderSummaryMsgPs();

  // すでに ?param が付いている（戻る遷移など）時は初期化しない方が親切なケースが多い
  if (skipWhenQuery && location.search) return;

  // フォーム全体をまず reset（HTMLのchecked/selectedなどに戻る）
  const form = document.forms.frm_detail;
  if (form) form.reset();

  // ---- ここから「JSで上書きしたい初期値」を集中管理 ----
  // 追加：colortype1/2/3 と bubble の初期化
  ["colortype1","colortype2","colortype3"].forEach((name) => {
    const radios = document.querySelectorAll(`input[name="${name}"]`);
    if (!radios.length) return;
    radios.forEach(r => { if (r.checked) r.checked = false; });
    const section = radios[0].closest(".form.material");
    const bubble  = section?.querySelector(".material_bubble");
    if (bubble) bubble.textContent = "選択してください";
  });

  // 追加：Splideを元の全件状態に戻す
  ["colortype2","colortype3"].forEach((groupName) => {
    const root = document.querySelector(`input[name="${groupName}"]`)?.closest(".material")?.querySelector(".splide");
    if (root && root.__originalSlides) {
      const list = root.querySelector(".splide__list");
      list.innerHTML = "";
      root.__originalSlides.forEach(orig => list.appendChild(orig.cloneNode(true)));
      const splide = new Splide(root, root.splide?.options || {});
      splide.mount();
    }
  });

  const area2 = document.querySelector('img[name="area2"]');
  const area3 = document.querySelector('img[name="area3"]');
  const area4 = document.querySelector('img[name="area4"]');
  if (area2) area2.src = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/top/wood_br.png';
  if (area3) area3.src = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/mak/wood_br.png';
  if (area4) area4.src = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/leg/wood_br.png';

}



//画像切替
document.addEventListener("DOMContentLoaded", function () {

  const base = "https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/";

  // el: 選択中の<input type="radio">
  // part: 'top' | 'leg' | 'mak'
  function resolveImagePath(el, part) {
    if (!el) return null;
    const type = (el.dataset?.type || "").toLowerCase(); // wood/aino/mela
    // 末尾の 1/2/3 を除去（例: wood_whw1 → wood_whw）
    let token = (el.id || "").replace(/\d+$/, "").toLowerCase();

    return `${base}${part}/${token}.png`;
  }

  function updateImages() {
    const area2 = document.querySelector('img[name="area2"]'); // top
    const area3 = document.querySelector('img[name="area3"]'); // mak
    const area4 = document.querySelector('img[name="area4"]'); // leg

    const ct1 = document.querySelector('input[name="colortype1"]:checked');
    const ct2 = document.querySelector('input[name="colortype2"]:checked');
    const ct3 = document.querySelector('input[name="colortype3"]:checked');

    if (ct1 && area2) {
      const src = resolveImagePath(ct1, "top");
      if (src) area2.src = src;
    }
    if (ct2 && area4) {
      const src = resolveImagePath(ct2, "leg");
      if (src) area4.src = src;
    }
    if (ct3 && area3) {
      const src = resolveImagePath(ct3, "mak");
      if (src) area3.src = src;
    }
  }

  // どの colortype が変わっても反映
  document.addEventListener("change", function (e) {
    const t = e.target;
    if (!t.matches('input[name^="colortype"]')) return;
    if (!t.checked) return;
    updateImages();
  });

  // 既に選択済みがあれば初期ロード時に反映
  updateImages();
});




(() => {
  "use strict";

  // 1) 吹き出しに入れる説明文（1か所で管理）
  const materialTexts = {
    wood: "リーズナブル木目：<br>[材質]デルナチュレ化粧合板（ブラウン・ダークブラウン・北欧チーク）、強化紙化粧合板（ナチュラル・ホワイトウッド・オーク・ブラックウッド）、ポリエステル化粧合板（ホワイト）",
    aino: "パステルカラーaino：<br>[材質]強化紙化粧合板",
    mela: "ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)、プリント化粧合板",
  };

  // 2) 初期化関連
  const INITIAL_BUBBLE_TEXT = "選択してください";
  const DEPENDENT_NAMES = ["colortype2", "colortype3"]; // 連動初期化するグループ
  let lastGroupOfColorType1 = null; // "mela" or "other" を記憶（wood/ainoは "other"）

  const groupOf = (type) => (type === "mela" ? "mela" : "other");

  const getSectionByAnyInputName = (name) => {
    const any = document.querySelector(`input[name="${name}"]`);
    return any ? any.closest(".form.material") : null;
  };

  const setBubbleHTML = (section, html) => {
    const bubble = section && section.querySelector(".material_bubble");
    if (bubble) bubble.innerHTML = html;
  };

  const setBubbleText = (section, text) => {
    const bubble = section && section.querySelector(".material_bubble");
    if (bubble) bubble.textContent = text;
  };

  // 指定 name のラジオ群を未選択にして、吹き出しも初期化
  const resetDependentByName = (name) => {
    const inputs = document.querySelectorAll(`input[name="${name}"]`);
    if (!inputs.length) return;

    // ラジオ選択を外す
    inputs.forEach((i) => {
      if (i.checked) i.checked = false;
    });

    // 吹き出し初期化
    const section = inputs[0].closest(".form.material");
    setBubbleText(section, INITIAL_BUBBLE_TEXT);
  };

  // change で吹き出し更新
  const onChange = (e) => {
    const input = e.target;
    if (
      !input ||
      input.tagName !== "INPUT" ||
      input.type !== "radio" ||
      !/^colortype[123]$/.test(input.name)
    ) {
      return;
    }

    // 選択確定時のみ処理（false の change は無視）
    if (!input.checked) return;

    const section = input.closest(".form.material");
    const type = input.dataset?.type || null; // 本HTMLは全て data-type あり
    if (!type) return;

    // 自分の吹き出しを更新
    const html = materialTexts[type];
    if (html) setBubbleHTML(section, html);

    // colortype1 のグループ切替（mela ⇄ wood/aino）を検知
    if (input.name === "colortype1") {
      const currentGroup = groupOf(type);

      // 直近の状態
      const wasKnown  = lastGroupOfColorType1 !== null;
      const switched  = wasKnown && currentGroup !== lastGroupOfColorType1;

      // 依存選択の現状（未選択かどうか）
      const noCt2 = !document.querySelector('input[name="colortype2"]:checked');
      const noCt3 = !document.querySelector('input[name="colortype3"]:checked');

      // 画像ノード
      const area3 = document.querySelector('img[name="area3"]'); // mak
      const area4 = document.querySelector('img[name="area4"]'); // leg

      // 画像パス（共通で使う）
      const IMG = {
        mak_mela_nail: 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/mak/mela_nail.png',
        leg_mela_nail: 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/leg/mela_nail.png',
        mak_wood_br  : 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/mak/wood_br.png',
        leg_wood_br  : 'https://www.rakuten.ne.jp/gold/arne/size_order/images/hammer_bench/leg/wood_br.png'
      };

      if (currentGroup === 'mela') {
        // ① 初回にmelaを選んだ & colortype2/3未選択 → area3/4をmela_nailに
        if (!wasKnown && noCt2 && noCt3) {
          if (area3) area3.src = IMG.mak_mela_nail;
          if (area4) area4.src = IMG.leg_mela_nail;
        }

        // ② wood/aino → mela に切替えた場合：
        //    ・依存（脚/幕板）を未選択化
        //    ・area3/4 を mela_nail に
        if (switched) {
          DEPENDENT_NAMES.forEach(resetDependentByName);
          if (area3) area3.src = IMG.mak_mela_nail;
          if (area4) area4.src = IMG.leg_mela_nail;
        }
      } else {
        // mela → other(wood/aino) に切替えた場合の既存初期化はそのまま（必要なら維持）
        if (switched) {
          DEPENDENT_NAMES.forEach(resetDependentByName);
          if (area3) area3.src = IMG.mak_wood_br;
          if (area4) area4.src = IMG.leg_wood_br;
        }
      }
      // 最後に現在グループを記憶
      lastGroupOfColorType1 = currentGroup;
    }
  };

  // 既にチェック済みがあれば、ロード時に吹き出しを反映＆基準グループを記憶
  const hydrateFromChecked = () => {
    ["colortype1", "colortype2", "colortype3"].forEach((name) => {
      const checked = document.querySelector(`input[name="${name}"]:checked`);
      const section = getSectionByAnyInputName(name);
      if (!section) return;

      if (checked && checked.dataset?.type && materialTexts[checked.dataset.type]) {
        setBubbleHTML(section, materialTexts[checked.dataset.type]);
      } else {
        setBubbleText(section, INITIAL_BUBBLE_TEXT);
      }
    });

    const ct1Checked = document.querySelector(`input[name="colortype1"]:checked`);
    if (ct1Checked?.dataset?.type) {
      lastGroupOfColorType1 = groupOf(ct1Checked.dataset.type);
    } else {
      lastGroupOfColorType1 = null;
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    // 変更を一括で拾う
    document.addEventListener("change", onChange, { passive: true });
    hydrateFromChecked();
  });
})();



//選択可能な材質の絞り込み
document.addEventListener("DOMContentLoaded", function () {
  // --- ユーティリティ -----------------------------------------

  // groupName から、そのグループの Splide ルート(.splide)を取得
  function getSplideRootByGroupName(groupName) {
    const anyInput = document.querySelector(`input[name="${groupName}"]`);
    if (!anyInput) return null;
    // マークアップ構造: .material -> .splide -> .splide__track -> .splide__list -> .splide__slide
    return anyInput.closest(".material")?.querySelector(".splide") || null;
  }

  // ルートの .splide__list を取得
  function getListEl(root) {
    return root?.querySelector(".splide__list") || null;
  }

  // 初回に元スライドを退避（深いcloneを保持）
  function captureOriginalSlides(root) {
    if (!root) return;
    if (root.__originalSlides) return; // すでに退避済みならスキップ

    const list = getListEl(root);
    if (!list) return;

    const originals = [];
    list.querySelectorAll(".splide__slide").forEach((slide) => {
      // 後で安全に差し替えできるよう、cloneNode(true)で保持
      originals.push(slide.cloneNode(true));
    });
    root.__originalSlides = originals;
  }

  // predicate に合致するスライド群で .splide__list を再構築
  function rebuildWithPredicate(root, predicate) {
    if (!root || !root.__originalSlides) return;

    const instance = root.splide;
    let options;
    if (instance) {
      // 既存オプションをほぼそのまま再利用（参照切っておく）
      try {
        options = JSON.parse(JSON.stringify(instance.options));
      } catch (_) {
        options = instance.options || undefined;
      }
      // 既存を破棄（trueでクリーンアップ）
      instance.destroy(true);
    }

    const list = getListEl(root);
    if (!list) return;

    // 一旦空に
    list.innerHTML = "";

    // 条件に合うスライドだけを復元
    const filtered = [];
    root.__originalSlides.forEach((orig) => {
      // 各スライド内の input[type=radio] の data-type を判定
      const radio = orig.querySelector('input[type="radio"]');
      const type = radio?.dataset?.type || "";
      if (predicate(type)) {
        filtered.push(orig.cloneNode(true));
      }
    });

    // 万一0件なら、UX劣化を避けるため「全件復元」にフォールバック
    const slidesToUse = filtered.length > 0 ? filtered : root.__originalSlides.map(s => s.cloneNode(true));

    slidesToUse.forEach((node) => list.appendChild(node));

    // リマウント
    try {
      // 既存の初期化ロジックと競合しないよう、直接 new Splide で再マウント
      const splide = new Splide(root, options);
      splide.mount();
    } catch (_) {
      // 念のための保険（グローバル初期化関数があるなら呼ぶ）
      if (typeof window.initAllSplides === "function") {
        window.initAllSplides();
      }
    }

  }

  // colortype1 の値から predicate を生成
  // 仕様：
  // - colortype1 = "mela"   → 2,3は「melaのみ」表示
  // - colortype1 = wood/aino→ 2,3は「mela以外」表示
  function buildPredicateFromType(selectedType) {
    if (selectedType === "mela") {
      return (t) => t === "mela";
    }
    return (t) => t !== "mela";
  }

  // 現在の選択情報を取得
function getCurrentSelection(groupName) {
  const checked = document.querySelector(`input[name="${groupName}"]:checked`);
  if (!checked) return null;
  return { id: checked.id, name: checked.name, value: checked.value };
}

// rebuildWithPredicate を「prevSel」を受け取れるよう拡張
function rebuildWithPredicate(root, predicate, prevSel) {
  if (!root || !root.__originalSlides) return;

  const instance = root.splide;
  let options;
  if (instance) {
    try { options = JSON.parse(JSON.stringify(instance.options)); }
    catch (_) { options = instance.options || undefined; }
    instance.destroy(true);
  }

  const list = root.querySelector(".splide__list");
  if (!list) return;
  list.innerHTML = "";

  const filtered = [];
  root.__originalSlides.forEach((orig) => {
    const radio = orig.querySelector('input[type="radio"]');
    const type = radio?.dataset?.type || "";
    if (predicate(type)) filtered.push(orig.cloneNode(true));
  });
  const slidesToUse = filtered.length ? filtered : root.__originalSlides.map(s => s.cloneNode(true));
  slidesToUse.forEach((n) => list.appendChild(n));

  try {
    const splide = new Splide(root, options);
    splide.mount();
  } catch (_) {
    if (typeof window.initAllSplides === "function") window.initAllSplides();
  }

  // 可能なら“以前の選択”を復元
  if (prevSel) {
    let restore =
      (prevSel.id && list.querySelector(`#${window.CSS?.escape ? CSS.escape(prevSel.id) : prevSel.id}`)) ||
      list.querySelector(`input[name="${prevSel.name}"][value="${prevSel.value}"]`);
    if (restore) {
      restore.checked = true;
      // 吹き出しも既存の onChange で反映させる
      restore.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

  // groupName を対象に「現在の colortype1 に応じたフィルター」を適用
  function applyFilterToGroup(groupName, selectedType) {
    const root = getSplideRootByGroupName(groupName);
    if (!root) return;
    captureOriginalSlides(root);
    const predicate = buildPredicateFromType(selectedType);
    const prevSel = getCurrentSelection(groupName);
    rebuildWithPredicate(root, predicate, prevSel);
  }

  // --- 監視＆初期反映 -----------------------------------------

  // colortype1 の変更を監視
  const ct1 = document.querySelectorAll('input[name="colortype1"]');
  ct1.forEach((input) => {
    input.addEventListener("change", function () {
      if (!this.checked) return;
      const selectedType = this.dataset.type; // "mela" / "wood" / "aino"
      // name="colortype2" と name="colortype3" に適用
      applyFilterToGroup("colortype2", selectedType);
      applyFilterToGroup("colortype3", selectedType);
    });
  });

  // 初期反映（ページロード時の選択状態に合わせる）
  const initChecked = document.querySelector('input[name="colortype1"]:checked');
  if (initChecked) {
    const selectedType = initChecked.dataset.type;
    applyFilterToGroup("colortype2", selectedType);
    applyFilterToGroup("colortype3", selectedType);
  }
});



document.addEventListener("DOMContentLoaded", () => {
  // 既存の初期化
  resetToDefaults({ skipWhenQuery: false });

  function resizeFormSizeImages() {
    const container = document.querySelector(".form_size--img");
    if (!container) return;

    const width = container.offsetWidth;
    const imgs = container.querySelectorAll("img");

    // 1) 各imgに幅を反映
    imgs.forEach(img => {
      img.style.width = width + "px";
    });

    // 2) 代表の画像（最初の1枚など）の高さを使う
    const firstImg = imgs[0];
    if (firstImg) {
      // レイアウトが更新された後に高さを拾うため setTimeout を使用
      setTimeout(() => {
        const h = firstImg.offsetHeight;
        if (h > 0) {
          container.style.height = h + "px";
        }
      }, 0);
    }
  }

  // 初期化
  resizeFormSizeImages();

  // リサイズ時にも再適用
  window.addEventListener("resize", resizeFormSizeImages);
});

// --- サイズ範囲チェック (.form_size--txt) -----------------------
(() => {
  "use strict";

  // 入力許容範囲をここで一元管理（要件に合わせて編集可）
  const LIMITS = {
    haba:   { min: 30, max: 150, label: "幅" },
    depth:  { min: 30, max: 45,  label: "奥行" },
    height: { min: 30, max: 60, label: "高さ" },
  };

  // 数字だけに正規化
  const onlyDigits = (v) => v.replace(/[^\d]/g, "");

  // 値の取得＆正規化
  function readInt(id) {
  const el = document.getElementById(id);
  if (!el) return { el: null, val: NaN, isEmpty: true };
  const cleaned = onlyDigits(el.value);
  if (el.value !== cleaned) el.value = cleaned; // 非数字は都度除去
  const isEmpty = cleaned === "";
  const n = isEmpty ? NaN : parseInt(cleaned, 10);
  return { el, val: n, isEmpty };
  }

  // 入力枠のエラースタイル
  function toggleError(el, on) {
    if (!el) return;
    el.classList.toggle("is-error", !!on);
    el.setAttribute("aria-invalid", on ? "true" : "false");
  }

  // メッセージ表示先（「ご希望サイズの入力」ブロック直後の .msg）
  function $sizeMsg() {
    const node = document.querySelector(".form_size + .msg");
    return node ? $(node) : $();
  }

  // グローバル公開：他の箇所からも呼べるように
  // ② checkSize 内のループとメッセージ処理を差し替え
window.checkSize = function () {
  const $msg = $sizeMsg();
  $msg.find(".note-size-error, .note-size-ok").remove();

  const errors = [];
  let allFilled = true;

  ["haba", "depth", "height"].forEach((id) => {
    const { el, val, isEmpty } = readInt(id);
    const lim = LIMITS[id];
    const label = lim.label;

    let bad = false;

    if (isEmpty) {
      // 空欄はエラーにしない（ただし “OK” 表示の対象外）
      allFilled = false;
      bad = false;
    } else if (Number.isNaN(val)) {
      bad = true;
      errors.push(`${label}は数値(半角)で入力してください`);
    } else if (val < lim.min || val > lim.max) {
      bad = true;
      errors.push(`${label}は ${lim.min}～${lim.max}cm の範囲で入力してください（現在: ${val}cm）`);
    }

    toggleError(el, bad);
  });

  if (errors.length) {
    //$msg.append($('<p class="note-size-error">').text("入力エラーがあります。内容をご確認ください。"));
    errors.forEach(t => $msg.append($('<p class="note-size-error">').text(t)));
    return false;
  } else {
    return false;// 3項目すべて入力済みなら true、空欄ありは false
  }
};

  // テキスト入力の「change」と幕板サイズセレクトの変更をチェック
  $(document).on("change", ".form_size--txt input[type='text']", window.checkSize);

  // 入力中も数字以外は弾く（maxlengthはHTML側に既に設定あり）
  $(document).on("input", ".form_size--txt input[type='text']", function () {
    const cleaned = this.value.replace(/[^\d]/g, "");
    if (this.value !== cleaned) this.value = cleaned;
  });

  // 初期描画時にも一度チェック（戻る遷移などに対応）
  document.addEventListener("DOMContentLoaded", window.checkSize);
})();

// --- depth→min_depth と 幕板サイズ→幕板高さ の自動反映 -----------------
(() => {
  "use strict";

  // 数字だけに整える→整数へ
  const toInt = (el) => {
    if (!el) return NaN;
    const cleaned = String(el.value || "").replace(/[^\d]/g, "");
    if (el.value !== cleaned) el.value = cleaned; // 非数字は都度除去
    return cleaned === "" ? NaN : parseInt(cleaned, 10);
  };

  // 2) mak_size / height 変更 → mak_height 更新
  //   ショート: floor(height/3)
  //   ハーフ  : floor(height/2)
  //   ロング  : height - 2
  function updateMakHeight() {
    const heightEl = document.getElementById("height");
    const sizeSel  = document.getElementById("mak_size");
    const outEl    = document.getElementById("mak_height");
    if (!heightEl || !sizeSel || !outEl) return;

    const h = toInt(heightEl);
    if (Number.isNaN(h)) {
      outEl.value = "";
      return;
    }

    const sizeName = sizeSel.value; // ハーフのみ
    let val;
    val = Math.floor(h / 2);
    outEl.value = "約 " + val;
  }

  // 既存の checkSize があれば、完了後に同期させる（任意）
  if (typeof window.checkSize === "function") {
    const orig = window.checkSize;
    window.checkSize = function () {
      const r = orig.apply(this, arguments);
      updateMakHeight();
      return r;
    };
  }

  // 監視（リアルタイムに反映）
  document.addEventListener("DOMContentLoaded", () => {
    // height 入力や mak_size の選択変更で幕板高さを更新
    $(document).on("input change", "#height", updateMakHeight);
    $(document).on("change", "#mak_size", updateMakHeight);

    // 初期化（履歴戻りや既定値がある場合に備える）
    updateMakHeight();
  });
})();



// --- 送信前バリデーション & 確認欄への反映（check_area新順対応版） ----------
(() => {
  "use strict";

  const LIMITS = { haba: [30, 150], depth: [30, 45], height: [30, 60] };
  const LABELS = { haba: "幅", depth: "奥行", height: "高さ" };

  function readIntRequired(id, [min, max], label, errors) {
    const el = document.getElementById(id);
    const raw = String(el?.value ?? "").replace(/[^\d]/g, "");
    if (raw === "") { errors.push(`${label}を入力してください`); return NaN; }
    const n = parseInt(raw, 10);
    if (Number.isNaN(n)) {
      errors.push(`${label}は数値(半角)で入力してください`);
    } else if (n < min || n > max) {
      errors.push(`${label}は ${min}～${max}cm の範囲で入力してください（現在: ${n}cm）`);
    }
    return n;
  }

  function checkedValue(name) {
    const el = document.querySelector(`input[name="${name}"]:checked`);
    return el ? el.value : null;
  }

  // onClick="return jump()" から呼ばれる
window.jump = function jump() {
  const $msg = $('.order-summary > .msg');
  $msg.empty();

  const errors = [];
  const LIMITS = { haba: [30, 150], depth: [30, 45], height: [30, 60] };
  const LABELS = { haba: "幅", depth: "奥行", height: "高さ" };

  // 必須数値の取得＆検証
  function readIntRequired(id, [min, max], label) {
    const el = document.getElementById(id);
    const raw = String(el?.value ?? "").replace(/[^\d]/g, "");
    if (raw === "") { errors.push(`${label}を入力してください`); return NaN; }
    const n = parseInt(raw, 10);
    if (Number.isNaN(n)) {
      errors.push(`${label}は数値(半角)で入力してください`);
    } else if (n < min || n > max) {
      errors.push(`${label}は ${min}～${max}cm の範囲で入力してください（現在: ${n}cm）`);
    }
    return n;
  }
  function checkedValue(name) {
    const el = document.querySelector(`input[name="${name}"]:checked`);
    return el ? el.value : null;
  }

  // --- 入力チェック ---
  const haba   = readIntRequired("haba",   LIMITS.haba,   LABELS.haba);
  const depth  = readIntRequired("depth",  LIMITS.depth,  LABELS.depth);
  const height = readIntRequired("height", LIMITS.height, LABELS.height);

  const colorTop  = checkedValue("colortype1");
  const colorLeg  = checkedValue("colortype2");
  const colorMaku = checkedValue("colortype3");
  if (!colorTop || !colorLeg || !colorMaku) {
    errors.push("天板カラー／脚カラー／幕板カラーをすべて選択してください");
  }

  // ハンマー
  const hammer =
    document.getElementById("op_hammerYes")?.checked ? "必要" :
    document.getElementById("op_hammerNo")?.checked  ? "不要" : null;
  if (!hammer) errors.push("組立て用ハンマーの「必要 / 不要」を選択してください");

  // エラー表示
  if (errors.length) {
    errors.forEach(t => $msg.append($('<p class="note-submit-error">').text(t)));
    setCheckoutUIEnabled(false);
    return false;
  }

  // --- 確認欄へ反映 ---
  const spans = document.querySelectorAll(".check_area ul li span");
  if (spans.length >= 7) {
    spans[0].textContent = haba;                               // 幅
    spans[1].textContent = depth;                              // 奥行
    spans[2].textContent = height;                             // 高さ
    spans[3].textContent = colorTop;                           // 天板カラー
    spans[4].textContent = colorLeg;                           // 脚カラー
    spans[5].textContent = colorMaku;                          // 幕板カラー

    spans[6].textContent = hammer;                            // ハンマー

    priceCheck();
  }

  // --- 既製品チェック ---
  const code = findExistingCodeFromSelection(); // 一致すればA列コード、なければ null
  if (code) {
    const hammerNo = document.getElementById("op_hammerNo")?.checked;
    const hammerNote = hammerNo ? '<br>ご注文時、備考欄に「ハンマー不要」とご記入ください' : '';

    $msg.append(
      $('<p>').append(
        $('<a>')
          .attr('href', 'https://interior-arne.com/products/' + code)//★店舗別に変更対象
          .attr('target', '_blank')
          .html('→既製品ページがございます。こちらのページよりお買い求めください。' + hammerNote)
      )
    );

    clearCheckArea();            // .check_area 初期化
    setCheckoutUIEnabled(false); // .check_price と .cart--btn を初期化（非表示/無効化）
    return false;
  }

  // --- 通常成功 ---
  setCheckoutUIEnabled(true); // 価格＆カート有効化（表示/有効）
  $msg.append(
    $('<p class="note-submit-ok">').text('以下の内容を確認し、買い物かごにお進みください。')
  );
  return false;
};
})();


// --- 「結果表示」を編集操作でリセットする仕組み ------------------
function clearCheckArea() {
  // 「この条件で金額算出」ボタンで埋めている確認表示のクリア
  // 例: .check_area 内の <span> を空に
  const root = document.querySelector('.check_area');
  if (!root) return;
  root.querySelectorAll('span').forEach((s) => { s.textContent = ''; });
}

// 編集操作時の共通リセット
function resetOutputsByUserEdit() {
  setCheckoutUIEnabled(false); // 価格・カートの初期化（visibility/disabled の初期状態へ）
  clearCheckArea(); // .check_area / .check--area のクリア
  removeOrderSummaryMsgPs(); // .order-summary .msg 内の <p> を全削除
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.forms.frm_detail; // HTML側のフォーム:contentReference[oaicite:3]{index=3}
  if (!form) return;

  // 入力中の逐次反映（text/number/textarea）
  form.addEventListener('input', function (e) {
    const t = e.target;
    if (!t) return;
    if (t.matches('input[type="text"], input[type="number"], textarea')) {
      resetOutputsByUserEdit();
    }
  }, true);

  // 選択の確定（radio/checkbox/select）
  form.addEventListener('change', function (e) {
    const t = e.target;
    if (!t) return;

    // 金額算出ボタン自体のクリックではリセットしない（保険）
    if (t.matches('button, input[type="submit"], input[type="button"]')) return;

    if (t.matches('input[type="radio"], input[type="checkbox"], select')) {
      resetOutputsByUserEdit();
    }
  }, true);
});

// --- .order-summary の .msg 内の <p> を丸ごと削除 -------------------
function removeOrderSummaryMsgPs() {
  const msgs = document.querySelectorAll('.order-summary .msg');
  if (!msgs.length) return;
  msgs.forEach(msg => {
    msg.querySelectorAll('p').forEach(p => p.remove());
  });
}

// 現在の選択値をCSV行と突き合わせ、合致したらA列コードを返す
function findExistingCodeFromSelection() {

  // 選択値の取得
  const ct1 = document.querySelector('input[name="colortype1"]:checked');
  const ct2 = document.querySelector('input[name="colortype2"]:checked');
  const ct3 = document.querySelector('input[name="colortype3"]:checked');

  const ct1Type  = ct1?.dataset?.type || "";
  const ct2Type  = ct2?.dataset?.type || "";
  const ct3Type  = ct3?.dataset?.type || "";
  const ct1Value = ct1?.value || "";
  const ct2Value = ct2?.value || "";
  const ct3Value = ct3?.value || "";

  // --- 特例条件チェック ---
  if (
    (ct1Type === "wood" && ct2Type === "wood") ||
    (ct1Type === "aino" && ct2Type === "aino")
  ) {
    if (ct1Value && ct2Value && ct1Value !== ct2Value) {
      // 両方woodまたはainoで、valueも一致 → 処理クリア
      return null;
    }
  }

  // CSV未読や空なら不一致扱い
  if (!Array.isArray(kizonList) || kizonList.length === 0) return null;

  const onlyDigits = (s) => String(s || '').replace(/[^\d]/g, '');
  const haba   = onlyDigits(document.getElementById('haba')?.value);
  const depth  = onlyDigits(document.getElementById('depth')?.value);
  const height = onlyDigits(document.getElementById('height')?.value);

  // colortype1 が mela のときだけ「Top/Leg は value、Maku は data-type」、それ以外は全部 data-type
  let colorTop, colorLeg, colorMaku;
  if (ct1Type === 'mela') {
    colorTop  = ct1?.value || '';
    colorLeg  = ct2?.value || '';
    colorMaku  = ct3?.dataset?.type || '';
  } else {
    colorTop  = ct1?.dataset?.type || '';
    colorLeg  = ct2?.dataset?.type || '';
    colorMaku  = ct3?.dataset?.type || '';
  }

  // CSV走査（先頭ヘッダー行はスキップ認識）
  for (const row of kizonList) {
    // CSV列: A:コード / B:幅 / C:奥行 / D:高さ / E:天板カラー / F:脚カラー / G:幕板カラー
    const [code, cHaba, cDepth, cHeight, cTop, cLeg, cMaku] = row.map(v => (v ?? '').toString().trim());
    if (!code) continue;

    // ヘッダーっぽい行は飛ばす
    if ((cHaba || '').includes('幅') && (cDepth || '').includes('奥行')) continue;

    const isMatch =
      onlyDigits(cHaba)  === haba &&
      onlyDigits(cDepth) === depth &&
      onlyDigits(cHeight)=== height &&
      cTop               === colorTop &&
      cLeg               === colorLeg &&
      cMaku              === colorMaku;

    if (isMatch) return code; // A列の既製品コードを返す
  }

  return null; // 見つからなければ不一致
}

function priceCheck() {
  // 入力値を数値で取得（半角数字以外を除去）
  const readInt = (id) => {
    const v = (document.getElementById(id)?.value || "").replace(/[^\d]/g, "");
    return v === "" ? NaN : parseInt(v, 10);
  };
  const haba   = readInt("haba");   // 幅
  const depth  = readInt("depth");  // 奥行
  const height = readInt("height"); // 高さ
  const mak_h = readInt("mak_height"); // 幕板サイズ

  const selected = document.querySelector('input[name="colortype1"]:checked');
  const type = selected?.dataset?.type;

  if (type === "wood" || type === "aino") {// wood/aino の価格算出
    $.ajax({
      url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_price_6278c8a2-7d96-431e-82ba-570c72bb37ba.csv?v=1762475396",
      dataType: "text",
      success: function(data) {
        const priceList = $.csv.toArrays(data); // CSV → 2次元配列

        const w = haba <= 30 ? 0 : Math.ceil((haba - 30) / 5);//幅300以下は0、以降50cmごとに1加算
        const d = (depth <= 15 ? 0 : Math.ceil((depth - 15) / 5))
                + (height >= 90 ? 32 : height >= 60 ? 16 : 0);//奥行150以下は0、以降50cmごとに1加算。高さ591以上で16、900以上で32加算

        const price = Number(priceList?.[d]?.[w] ?? 0);

        let total = price;

      var idx = $('#mak_size option:selected').index();
      //幕板サイズによる加算
      switch(idx){
        case 0:break;
        case 1:total = Math.ceil( price * 1.05 /100)*100;break;
        case 2:total = Math.ceil( price * 1.15 /100)*100;break;
      }
      //化粧紙・メラミン共通 幕板ロングのみYHC価格
      if(90 <= height){
        switch(idx){
        case 0:break;
        case 1:break;
        case 2:if(idx == 2){total = total + 3500;}break;
        }
      }

        const priceBox = document.querySelector('.check_price');
        if (priceBox) {
          priceBox.textContent = total.toLocaleString() + "円";
        }

        syncHiddenChoices();

      }
    });
  } else if (type === "mela") { // mela の価格算出
    const readInt = (id) => {
      const v = (document.getElementById(id)?.value || "").replace(/[^\d]/g, "");
      return v === "" ? NaN : parseInt(v, 10);
    };
    const haba   = readInt("haba");
    const depth  = readInt("depth");
    const height = readInt("height");
    const mak_h  = readInt("mak_height");

    // インデックス計算
    const w_top = haba <= 30 ? 0 : Math.ceil((haba - 30) / 5);
    let   d_top = depth <= 15 ? 0 : Math.ceil((depth - 15) / 5);
    const topCode = (document.querySelector('input[name="colortype1"]:checked')?.value || '').toUpperCase();
    if (["MB","GS","WW"].includes(topCode)) d_top += 16;

    const d_leg = height <= 45 ? 0 : Math.ceil((height - 45) / 5);
    let   h_leg = (depth <= 15) ? 0 : Math.ceil((depth - 15) / 5);
    const legCode = (document.querySelector('input[name="colortype2"]:checked')?.value || '').toUpperCase();
    if (["MB","GS","WW"].includes(legCode)) h_leg += 16;

    const w_mak  = w_top; // 幅は天板と同じ刻み
    let   h_mak = (mak_h <= 15) ? 0 : Math.ceil((mak_h - 15) / 5);
    const makCode = (document.querySelector('input[name="colortype3"]:checked')?.value || '').toUpperCase();
    if (["MB","GS","WW"].includes(makCode)) h_mak += 18;

    // CSVをまとめて取得
    Promise.all([
      $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_metop_94a69188-e6f9-40fe-8e86-a5535a53baf7.csv?v=1762475397", dataType: "text" }),
      $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_meleg_546ca790-a244-41d1-9d1d-d3e6c8c071fb.csv?v=1762475396", dataType: "text" }),
      $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hammer_memak_d8ac4474-f487-426d-a0ea-55d60110c590.csv?v=1762475396", dataType: "text" })
    ]).then(([metopTxt, melegTxt, memakTxt]) => {
      const metop = $.csv.toArrays(metopTxt); // 天板
      const meleg = $.csv.toArrays(melegTxt); // 脚
      const memak = $.csv.toArrays(memakTxt); // 幕板

      // 価格取得（脚は×2）
      const priceTop = Number(metop?.[d_top]?.[w_top] ?? 0);
      const priceLeg = Number(meleg?.[h_leg]?.[d_leg] ?? 0) * 2;
      const priceMak = Number(memak?.[h_mak]?.[w_mak] ?? 0);

      const price = priceTop + priceLeg + priceMak;

      let total = price;

      var idx = $('#mak_size option:selected').index();
      //化粧紙・メラミン共通 幕板ロングのみYHC価格
      if(90 <= height){
        switch(idx){
        case 0:break;
        case 1:break;
        case 2:if(idx == 2){total = total + 3500;}break;
        }
      }

      const priceBox = document.querySelector('.check_price');
      if (priceBox) {
        priceBox.textContent = total.toLocaleString() + "円";
      }
      
      syncHiddenChoices();

    }).catch(() => {
      // 失敗時は何もしない（必要ならエラー表示）
    });
  }
}


window.addEventListener('pageshow', function () {
  try {
    // --- 1) まず form.reset() を明示 + 余裕のため2回（稀に復元が強いブラウザ対策）
    const form = document.forms['frm_detail'] || document.querySelector('form[name="frm_detail"]');
    if (form) {
      form.reset();
      setTimeout(() => form.reset(), 0);
    }

    // --- 2) ラジオ/チェックを強制クリア（.form_radio--btn 配下も含む）
    document.querySelectorAll('.form_radio--btn input[type="radio"], .form_radio--btn input[type="checkbox"]').forEach(el => {
      el.checked = false;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // colortype1/2/3 グループも明示クリア
    ['colortype1','colortype2','colortype3'].forEach(name => {
      document.querySelectorAll(`input[name="${name}"]`).forEach(el => {
        el.checked = false;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // --- 3) .form_size--txt 内の入力値を強制クリア（text / number 両方）
    document.querySelectorAll('.form_size--txt input[type="text"], .form_size--txt input[type="number"]').forEach(el => {
      el.value = '';
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // --- 4) 既存初期化も実行（UI・msg・.check_area など）
    if (typeof setCheckoutUIEnabled === 'function') setCheckoutUIEnabled(false);
    if (typeof removeOrderSummaryMsgPs === 'function') removeOrderSummaryMsgPs();
    if (typeof clearCheckArea === 'function') clearCheckArea();

    // 画像など他UIは必要に応じてここで初期化
    // if (typeof resetPreviewImages === 'function') resetPreviewImages();

    // --- 5) 最後に resetToDefaults を呼んで「初期状態」へ（左天板など既定値）
    if (typeof resetToDefaults === 'function') {
      resetToDefaults({ skipWhenQuery: false });
    }

  } catch (e) {
    // noop
  }
}, { passive: true });





// ▼ hidden の choice1〜8 と units を埋める
// .check_area → choice へ反映
function syncHiddenChoices() {
  // 1) .check_area の li を上から取得（0〜10が「幅〜ハンマー」）
  const lis = document.querySelectorAll('.check_area ul li');
  const getLiText = (i) => (lis[i]?.innerText || '').replace(/\s+/g, ' ').trim();
  const setChoice = (n, v) => {
    const el = document.getElementById(`choice${n}`);
    if (el) el.value = v;
  };

  // 2) choice1〜11：各 li のテキストをそのまま使い、末尾に「/」を付与
  for (let i = 0; i <= 6; i++) {
    const text = getLiText(i);
    setChoice(i + 1, text ? text + '/' : '');
  }

  const priceTxt = document.querySelector('.check_price')?.textContent || '';
  const priceNumOnly = (priceTxt.match(/\d+/g) || []).join(''); // カンマ/円を除去して数字連結
  setChoice(8, priceNumOnly ? `見積もり金額：${priceNumOnly}` : '');

  // units：単価100で割った値（価格がない時は1）
  const unitsEl = document.getElementById('units');
  if (unitsEl) {
    const priceNum = parseInt(priceNumOnly, 10) || 0;
    unitsEl.value = priceNum > 0 ? Math.floor(priceNum / 100) : 1;
  }
}



document.addEventListener("DOMContentLoaded", function () {
document.getElementById("modal-cart").addEventListener("click", function (event) {
event.preventDefault();
syncHiddenChoices();
let item_id = "10107666"; // ★RAC番号
let shop_bid = "203706"; // ★店舗ID
let variant_id = "555a00043"; // SKU移行後項目選択肢固有番号
let units = document.getElementById("units").value || "1"; // 個数（デフォルト: 1）
// `choice` の値を取得
let choiceList = [];
for (let i = 1; i <= 8; i++) {
let choiceElement = document.getElementById(`choice${i}`);
if (choiceElement) {
let value = choiceElement.value.trim();
if (value) {
choiceList.push(value);
}
}
}
let choiceString = choiceList.join("\r\n");
let unicodeArray = Encoding.stringToCode(choiceString);
let eucArray = Encoding.convert(unicodeArray, { 'to': 'EUCJP', 'from': 'UNICODE' });
let encodedChoice = Encoding.urlEncode(eucArray); // URLエンコード
let existingForm = document.querySelector("form[name='cart_form_ori']");
if (existingForm) {
existingForm.remove();
}
let form = document.createElement("form");
form.method = "post";
form.name = "cart_form_ori";
form.action = "https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set";
form.acceptCharset = "EUC-JP";
form.target = "_blank";
let inputs = [
{ name: "shop_bid", value: shop_bid },
{ name: "item_id", value: item_id },
{ name: "variant_id", value: variant_id },
{ name: "units", value: units },
{ name: "choice", value: encodedChoice }
];
inputs.forEach(inputData => {
let input = document.createElement("input");
input.type = "hidden";
input.name = inputData.name;
input.value = inputData.value;
form.appendChild(input);
});
document.body.appendChild(form); // フォームを DOM に追加
form.submit(); // フォーム送信
});
});